<div>
  placeholder for modern documents
</div>
